import {FC} from 'react';
import Button from 'components/Button';

type SupersendAddDocumentProps = {
    onClick?: () => void;
};

const SupersendAddDocument: FC<SupersendAddDocumentProps> = ({onClick}) => (
    <Button
        className="size-[50px]"
        icon="add"
        kind="secondary"
        onClick={onClick}
    />
);

export default SupersendAddDocument;
